import { useQuery } from "@tanstack/react-query";
import { BDOW_SITES } from "../../constants/QueryKeys";
import UserService from "../../service/UserService";
import { STATIC_QUERY_DEFAULTS } from "../../utils/QueryUtils";

// Stable identity while loading so memoization keyed on bdowSites holds.
const EMPTY_SITES = Object.freeze([]);

/** @typedef {import("@/types/data/BdowSite.mjs").BdowSite} BdowSite */
/**
 * @template T
 * @typedef {import("@/types/TypeUtils.mjs").QueryResultRest<T>} QueryResultRest
 */
/**
 * @template T
 * @typedef {import("@/types/TypeUtils.mjs").QueryHookOptions<T>} QueryHookOptions
 */

const defaults = STATIC_QUERY_DEFAULTS;

/**
 * Fetches the BDOW! sites reachable by the caller's connected BDOW account.
 * The API returns an empty array when there is no (or a dead) BDOW connection.
 * @param {QueryHookOptions<BdowSite[]>} [options] - Extra `useQuery` options, spread over the defaults.
 * @returns {{ bdowSites: ReadonlyArray<BdowSite> } & QueryResultRest<BdowSite[]>}
 */
const useBdowSites = (options = {}) => {
  const { data, ...rest } = useQuery({
    queryKey: [BDOW_SITES],
    queryFn: () => UserService.getBdowSites(),
    ...defaults,
    ...options,
  });
  return { bdowSites: data ?? EMPTY_SITES, ...rest };
};

export default useBdowSites;
